import config from '~/config'
import { toBoolean } from '~/util/string'

export default function ({ redirect }) {
  if (toBoolean(config.isMaint)) {
    return redirect('/mantenimiento')
  }
}
